import { getCzechSuklRsAtcGroups } from '~/libs/infrastructure/api/availability';

import { SearchAutocompleteItem } from '../components/SearchAutocomplete';
import { buildGroupSlug } from './availabilitySlug';

const SEARCH_OPTIONS_PER_PAGE = 100;

export interface SearchAutocompleteOptionsResult {
	items: SearchAutocompleteItem[];
	totalCount: number;
}

export async function fetchSearchAutocompleteOptions(): Promise<SearchAutocompleteOptionsResult> {
	const response = await getCzechSuklRsAtcGroups({ page: 1, perPage: SEARCH_OPTIONS_PER_PAGE });

	return {
		items: response.items.map((group) => ({
			id: group.id,
			label: group.atc,
			slug: buildGroupSlug({ atc: group.atc, rs: group.rs }),
		})),
		totalCount: response.pagination.total,
	};
}
